import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PROJECTS } from "../constant/Projects";
import { SlCalender } from "react-icons/sl";
import { BsInfoLg } from "react-icons/bs";
import { GrLocation } from "react-icons/gr";
import { MdOutlineHandshake } from "react-icons/md";
import Slider from "react-slick";

const ProjectDetails = () => {
  const [project, setProject] = useState({});
  const { category, title } = useParams();
  useEffect(() => {
    setProject(
      PROJECTS.find((project) => project.url === category).projects.find(
        (project) =>
          project.url.toLowerCase().trim() === title.toLowerCase().trim()
      )
    );
  }, []);
  return (
    <section className="text-center md:text-left py-12">
      <div className="container flex items-center justify-evenly flex-wrap gap-5">
        <div className="w-[500px] max-sm:w-[300px]">
          {typeof project.img === "object" ? (
            <Slider
              slidesToScroll={1}
              slidesToShow={1}
              speed={500}
              infinite={true}
              dots={true}
              arrows={false}
              autoplay={true}
              autoplaySpeed={3000}
              dotsClass="slick-dots slick-thumb"
              customPaging={(i) => (
                <a className="max-sm:hidden">
                  <img src={`/images/toshka0${i + 1}.png`} />
                </a>
              )}
            >
              {project.img.map((img, i) => (
                <div key={i}>
                  <img
                    src={img}
                    alt="toshka"
                    className="rounded-[20px_0] w-full"
                    loading="lazy"
                  />
                </div>
              ))}
            </Slider>
          ) : (
            <img
              src={project.img}
              alt={project.title}
              className="rounded-[20px_0] w-full"
              loading="lazy"
            />
          )}
        </div>
        <div className="w-[500px] flex flex-col ml-5 mt-10">
          <h2 className="md:text-2xl text-xl font-bold">{project.title}</h2>
          <ul className="my-2 flex flex-col gap-5 p-2">
            <li className="flex items-center gap-4">
              <div>
                <BsInfoLg className="text-[30px]" />
              </div>
              {typeof project.description === "string" ? (
                <p
                  className="text-gray-500 text-[15px] md:text-[18px] text-left"
                  dangerouslySetInnerHTML={{ __html: project.description }}
                />
              ) : (
                <p className="text-black font-bold text-[18px] text-left">
                  {project.description?.info}
                  <ul className="flex gap-2 flex-col text-gray-500 font-normal mt-2">
                    {project.description?.subInfo.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </p>
              )}
            </li>
            {project?.partner && (
              <li className="flex items-center gap-4">
                <div>
                  <MdOutlineHandshake className="text-[30px] " />
                </div>
                <p className="text-gray-500 text-[15px] md:text-[18px]">
                  {project.partner}
                </p>
              </li>
            )}
            {project?.year && (
              <li className="flex items-center gap-4">
                <div>
                  <SlCalender className="text-[30px] " />
                </div>
                <p className="text-gray-500 text-[15px] md:text-[18px]">
                  {project.year}
                </p>
              </li>
            )}
            {project?.location && (
              <li className="flex items-center gap-4">
                <div>
                  <GrLocation className="text-[30px] " />
                </div>
                <p className="text-gray-500 text-left text-[15px] md:text-[18px]">
                  {project.location}
                </p>
              </li>
            )}
          </ul>
          <div></div>
        </div>
      </div>
    </section>
  );
};

export default ProjectDetails;
